import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonService, SeoService } from './shared/services';
import { LocalStorageService, StorageItem } from './shared/services/local-storage.service';
import { THEMES, ThemeService } from './shared/services/theme.service';

import { DeviceDetectorService } from 'ngx-device-detector';
import { Constants } from './shared/constants/app.constants';
import { DeviceInfoModel } from './shared/models/device-info.model';
import { CheckUpdateService } from './shared/services/check-update.service';
import { SplashScreenService } from './shared/services/splash-screen.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'customer_engagement_portal_client';
  showSwUpdateDialog = false;
  deviceInfoModel: DeviceInfoModel = new DeviceInfoModel();

  constructor(
    private readonly themeService: ThemeService,
    private readonly swUpdate: SwUpdate,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private readonly splashScreenService: SplashScreenService,
    private readonly router: Router,
    private readonly seoService: SeoService,
    private readonly deviceService: DeviceDetectorService,
    private readonly commonService: CommonService,
    private readonly cdr: ChangeDetectorRef,
    private readonly localStorageStorageService: LocalStorageService,
    private readonly checkUpdatesService: CheckUpdateService,
  ) {}

  ngOnInit(): void {
    const storedTheme = this.localStorageStorageService.getItem(StorageItem.Theme);
    this.checkUpdatesService.checkForUpdates();
    this.initializeRouterEventListener();
    this.setTheme(storedTheme as THEMES);
    this.runGlobalServices();
    this.getDeviceInfo();
  }

  initializeRouterEventListener() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, Constants.splashScreenTimeout);
      }
    });
  }

  setTheme(theme: THEMES): void {
    theme = theme ?? THEMES.LIGHT;
    this.themeService.changeTheme(theme);
  }

  private runGlobalServices(): void {
    this.seoService.init();
  }

  closeSwDialog(): void {
    this.showSwUpdateDialog = false;
    window.location.reload();
  }

  getDeviceInfo(): void {
    this.deviceInfoModel.deviceInfo = this.deviceService.getDeviceInfo();
    this.deviceInfoModel.isMobile = this.deviceService.isMobile(); // mobile-screen
    this.deviceInfoModel.isTablet = this.deviceService.isTablet(); // tablet-screen
    this.deviceInfoModel.isDesktop = this.deviceService.isDesktop(); // desktop-screen
    this.cdr.detectChanges();
  }
}
